import { PortableComponent, defineComponent } from '@decify/cell-shopify/client';
import { buttonClickEvent, buttonName } from '../Button';
import { overlayClickEvent, overlayName } from '../Overlay';
import { videoButtonName } from '../VideoButton';
import './Modal.scss';
export const modalName = 'Modal';
export const modalTagName = 'cell-component-modal';
export const modalOpenEvent = 'open';
export const modalCloseEvent = 'close';
export class Modal extends PortableComponent {
    classNames = {
        base: 'Modal',
        visible: 'Modal--Visible',
    };
    constructor() {
        super(modalName);
        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
    }
    componentDidMount() {
        globalThis.subscribe(`${buttonName}[${this.id}].${buttonClickEvent}`, this.open);
        globalThis.subscribe(`${videoButtonName}[${this.id}].${buttonClickEvent}`, this.open);
        this.subscribe(`${buttonName}[close].${buttonClickEvent}`, this.close);
        this.subscribe(`${overlayName}.${overlayClickEvent}`, this.close);
    }
    open() {
        this.classList.add(this.classNames.visible);
        this.publish(modalOpenEvent);
    }
    close() {
        this.classList.remove(this.classNames.visible);
        this.publish(modalCloseEvent);
    }
}
defineComponent(modalTagName, Modal);
